/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1LocationCountriesMutationRequest,
  PostApiV1LocationCountriesMutationResponse,
  PostApiV1LocationCountries400,
  PostApiV1LocationCountries401,
  PostApiV1LocationCountries409,
  PostApiV1LocationCountries500,
} from "../../types/locationCountryController/PostApiV1LocationCountries.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1LocationCountries } from "../../clients/locationCountryController/postApiV1LocationCountries.ts";

export const postApiV1LocationCountriesMutationKey = () =>
  [{ url: "/api/v1/location/countries" }] as const;

export type PostApiV1LocationCountriesMutationKey = ReturnType<
  typeof postApiV1LocationCountriesMutationKey
>;

export function postApiV1LocationCountriesMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<PostApiV1LocationCountriesMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const mutationKey = postApiV1LocationCountriesMutationKey();
  return mutationOptions<
    PostApiV1LocationCountriesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountries400
      | PostApiV1LocationCountries401
      | PostApiV1LocationCountries409
      | PostApiV1LocationCountries500
    >,
    { data?: PostApiV1LocationCountriesMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return postApiV1LocationCountries(data, config);
    },
  });
}

/**
 * @description Cria um novo país e a respectiva tradução no idioma corrente. A sigla e o nome devem ser únicos. **(Requer Authorization para autenticação)**
 * @summary Criar país (Requer Authorization para autenticação)
 * {@link /api/v1/location/countries}
 */
export function usePostApiV1LocationCountries<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1LocationCountriesMutationResponse,
      ResponseErrorConfig<
        | PostApiV1LocationCountries400
        | PostApiV1LocationCountries401
        | PostApiV1LocationCountries409
        | PostApiV1LocationCountries500
      >,
      { data?: PostApiV1LocationCountriesMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<
      RequestConfig<PostApiV1LocationCountriesMutationRequest>
    > & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ?? postApiV1LocationCountriesMutationKey();

  const baseOptions = postApiV1LocationCountriesMutationOptions(
    config,
  ) as UseMutationOptions<
    PostApiV1LocationCountriesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountries400
      | PostApiV1LocationCountries401
      | PostApiV1LocationCountries409
      | PostApiV1LocationCountries500
    >,
    { data?: PostApiV1LocationCountriesMutationRequest },
    TContext
  >;

  return useMutation<
    PostApiV1LocationCountriesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountries400
      | PostApiV1LocationCountries401
      | PostApiV1LocationCountries409
      | PostApiV1LocationCountries500
    >,
    { data?: PostApiV1LocationCountriesMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1LocationCountriesMutationResponse,
    ResponseErrorConfig<
      | PostApiV1LocationCountries400
      | PostApiV1LocationCountries401
      | PostApiV1LocationCountries409
      | PostApiV1LocationCountries500
    >,
    { data?: PostApiV1LocationCountriesMutationRequest },
    TContext
  >;
}
